// frontend/src/hooks/useAlarmMute.js
//
// Acceso al estado de silencio de alarmas desde cualquier componente.
// El estado real vive en `services/alarmMuteStore` (persistido por empresa), así
// que el Panel de Control y el gestor global de alarmas ven exactamente lo
// mismo aunque se monten en sitios distintos.

import { useCallback, useEffect, useState } from 'react';
import muteStore, {
  getMuteState,
  subscribeMute,
  toggleGlobalMute,
  toggleVehicleMute,
  clearVehicleMutes,
  setMuteCompany,
} from '../services/alarmMuteStore';

export const useAlarmMute = (companyId = null) => {
  const [state, setState] = useState(getMuteState);

  useEffect(() => {
    if (companyId) setMuteCompany(companyId);
  }, [companyId]);

  useEffect(() => subscribeMute(setState), []);

  const isMuted = useCallback(
    (vehicleId) => state.global || !!state.vehicles[String(vehicleId)],
    [state],
  );

  return {
    globalMute: state.global,
    vehicleMutes: state.vehicles,
    isVehicleMuted: isMuted,
    toggleGlobalMute,
    toggleVehicleMute,
    clearVehicleMutes,
  };
};

export default useAlarmMute;
export { muteStore };
